import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { AdminHeaderButton } from "@interfaces/adminHeaderButton.interface";
import { Client } from "@interfaces/models/client.interface";
import { FirewallLog } from "@interfaces/models/firewallLog.interface";
import { LogExport } from "@interfaces/logExport.interface";
import { Part } from "@interfaces/models/part.interface";
import { Project } from "@interfaces/project.interface";
import { UserProfile } from "@interfaces/userProfile.interface";
import { ClientService } from "@services/client.service";
import { ExportLogService } from "@services/exportLog.service";
import { FirewallLogService } from "@services/firewallLog.service";
import { PartService } from "@services/part.service";
import { ProjectService } from "@services/project.service";
import { ProtectedGridService } from "@services/protectedGrid.service";
import { UserProfileService } from "@services/userProfile.service";
import { ToastService } from "angular-toastify";

@Component({
	moduleId: module.id,
	selector: "firewallLogs",
	styleUrls: ["firewallLogs.css"],
	templateUrl: "firewallLogs.html"
})
export class FirewallLogsAdminComponent {
	canExportGrid = false;
	clients: Client[] = [];
	gridLoading = false;
	headerPrimaryButtons: AdminHeaderButton[] = [];
	itemType = "Firewall Log"
	itemUrl: string = location.href.split("/")[3] + "/" + location.href.split("/")[4];
	items: FirewallLog[] = [];
	parts: Part[] = [];
	projects: Project[] = [];
	title: string;
	userProfiles: UserProfile[] = [];
	
	constructor(private router: Router, private toastService: ToastService, private itemService: FirewallLogService, private clientService: ClientService, private exportLogService: ExportLogService, private partService: PartService, private projectService: ProjectService, private protectedGridService: ProtectedGridService, private userProfileService: UserProfileService) {
		this.headerPrimaryButtons.push({ icon: "fal fa-plus", method: "addNewItem", text: `New ${this.itemType}` });
		this.title = "Firewall Logs";
		this.viewRow = this.viewRow.bind(this);
		this.deleteRow = this.deleteRow.bind(this);
		this.getClients();
		this.getItems();
		this.getParts();
		this.getProjects();
		this.getUserProfiles();
		this.checkGridExportPermissions();
	}

	addNewItem() {
		this.router.navigate([`${this.itemUrl}/create`]);
	}
	
	checkGridExportPermissions() {
		this.protectedGridService.canExport("Firewall Logs")
			.subscribe(
				(res: any) => {
					this.canExportGrid = res.response;
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				},
			);
	}
	
	deleteRow(e: any) {
		const result = confirm("Are you sure you want to delete this firewall log?");
		if(result)
		{
			this.itemService.deleteSingleById(e.row.data.id)
				.subscribe(
					() => {
						this.toastService.success("Delivery note deleted!");
						this.getItems();
					},
					(err) => {
						console.log(err);
						this.toastService.error("Something Went Wrong!");
					},
				);
		}
	}
	
	getClients() {
		this.clientService.getAll()
			.subscribe(
				(res: any) =>  {
					this.clients = res.response.items;
				},
				(err) => console.log(err)
			);
	}

	getItems() {
		this.gridLoading = true;
		this.itemService.getAll()
			.subscribe(
				(res: any) => {
					this.items = res.response.items;
					this.gridLoading = false;
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				},
			);
	}
	
	getParts() {
		this.partService.getAll()
			.subscribe(
				(res: any) =>  {
					this.parts = res.response.items;
				},
				(err) => console.log(err)
			);
	}
	
	getProjects() {
		this.projectService.getAll()
			.subscribe(
				(res: any) =>  {
					this.projects = res.response.items;
				},
				(err) => console.log(err)
			);
	}
	
	getUserProfiles() {
		this.userProfileService.getActiveUsers()
			.subscribe(
				(res: any) =>  {
					this.userProfiles = res.response;
					this.userProfiles.sort((a,b) => a.fullName.localeCompare(b.fullName));
				},
				(err) => console.log(err)
			);
	}

	headerButtonClick(method: any) {
		// @ts-ignore // Required to be able to call the method directly from the variable
		if (this[method]) this[method]();
	}

	logExport() {
		const logExport = new LogExport();
		logExport.gridName = "Firewall Log";
		this.exportLogService.logExport(logExport)
			.subscribe(
				() => console.log("Export Logged"),
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
					return false;
				},
			);
	}

	viewRow(e: any) {
		this.router.navigate([`${this.itemUrl}/${e.row.data.lookupId}`]);
	}
}